import { useEffect, useState } from "react";
import axios from "axios";
import Marquee from "react-fast-marquee";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const tierColors = {
  platinum: "text-cyan-300",
  gold: "text-amber-400",
  silver: "text-zinc-300",
  bronze: "text-orange-400",
};

const tierBgColors = {
  platinum: "bg-cyan-300",
  gold: "bg-amber-400",
  silver: "bg-zinc-300",
  bronze: "bg-orange-400",
};

const Sponsors = () => {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    axios.get(`${API}/sponsors`).then((r) => setSponsors(r.data)).catch(console.error);
  }, []);

  return (
    <section id="sponsors" data-testid="sponsors-section" className="py-24 md:py-32 bg-zinc-900/30 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12">
        <div className="text-center">
          <span className="section-label">Partners & Sponsors</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white mt-4">
            Backed by <span className="gradient-text">industry leaders</span>
          </h2>
        </div>
      </div>

      {/* Marquee Row 1 */}
      <Marquee speed={40} gradient={false} className="py-6 border-y border-zinc-800">
        {sponsors.map((s) => (
          <div
            key={s.id}
            className="sponsor-item mx-8"
            data-testid={`sponsor-${s.id}`}
          >
            <span className={`text-xl sm:text-2xl font-bold tracking-tight ${tierColors[s.tier] || 'text-zinc-400'}`}>
              {s.name}
            </span>
          </div>
        ))}
      </Marquee>

      {/* Marquee Row 2 - reverse */}
      <Marquee speed={30} direction="right" gradient={false} className="py-6 border-b border-zinc-800">
        {[...sponsors].reverse().map((s) => (
          <div
            key={`rev-${s.id}`}
            className="sponsor-item mx-8"
          >
            <span className={`text-lg sm:text-xl font-semibold tracking-tight ${tierColors[s.tier] || 'text-zinc-400'} opacity-60`}>
              {s.name}
            </span>
          </div>
        ))}
      </Marquee>

      {/* Sponsor Tiers */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12">
        <div className="flex flex-wrap items-center justify-center gap-8 text-sm">
          {Object.entries(tierBgColors).map(([tier, bgColor]) => (
            <div key={tier} className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full ${bgColor}`} />
              <span className="text-zinc-500 uppercase tracking-wider text-xs font-medium">{tier}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
